<template>
  <div
    :class="{
      'h5-classify-tabs-wrap': isH5,
      'classify-tabs-wrap': !isH5,
      'electron-classify-tabs': isElectron,
    }"
  >
    <!-- 课程分类tabs -->
    <div
      class="classify-tabs"
      :class="{
        'hide-banner': hideBanner || activeId,
      }"
    >
      <div class="classify-content">
        <div class="scroll-content" ref="scrollContent">
          <div class="tablist-wrap">
            <div
              @click="changeTab(item.id)"
              :id="'tab-item-' + item.id"
              class="tab-item"
              :class="activeId === item.id ? 'is-active' : ''"
              v-for="item in tabList"
              :key="item.id"
            >
              {{ item.category_name }}
            </div>
          </div>
        </div>
        <div class="operate-wrap">
          <div v-if="!isH5" class="scroll-btn" v-show="canScroll">
            <i
              @click="scrollTab('left')"
              class="left-btn el-icon-arrow-left"
            ></i>
            <i
              @click="scrollTab('right')"
              class="right-btn el-icon-arrow-right"
            ></i>
          </div>

          <img
            @click="openDrawer"
            class="edit-btn"
            src="../../../assets/images/home/edit-icon.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <!-- 占位 -->
    <div class="placeholder-ele"></div>
  </div>
</template>

<script>
import { isH5 } from "@saas/components/src";
import { mapGetters } from "vuex";
export default {
  props: {
    tabList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    activeTabId: {
      type: Number,
      default: null,
    },
    bannerList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data: function () {
    return {
      isH5: isH5(),
      activeId: 0,
      canScroll: true,
      scrollTop: 0,
      isElectron: window.isElectron,
    };
  },
  mounted() {
    this.handleOperateBtn();
    // if (window.isElectron) {
    //   window.addEventListener("resize", this.setClassifyTabsEleWidth, true);
    //   this.setClassifyTabsEleWidth();
    // }
    if (!this.isH5) {
      // 监听滚动
      window.addEventListener("scroll", this.handleScroll, true);
    }
  },
  methods: {
    handleScroll() {
      if (this.activeId === 0) {
        if (window.isElectron) {
          const dom = document.getElementById("electron-main");
          if (dom) {
            this.scrollTop = dom.scrollTop;
          }
        } else {
          this.scrollTop = document.documentElement.scrollTop;
        }
      }
    },
    // setClassifyTabsEleWidth() {
    //   setTimeout(() => {
    //     let placeholderEle = document.getElementsByClassName("placeholder-ele");
    //     let classifyTabsEle = document.getElementsByClassName(" classify-tabs");
    //     if (placeholderEle?.length && classifyTabsEle?.length) {
    //       classifyTabsEle[0].style.width = placeholderEle[0].offsetWidth + "px";
    //     }
    //   }, 200);
    // },
    // 处理scroll按钮是否显示
    handleOperateBtn() {
      setTimeout(() => {
        let tablistWrapEle = document.getElementsByClassName("tablist-wrap");
        let scrollContentEle =
          document.getElementsByClassName("scroll-content");
        if (tablistWrapEle?.length && scrollContentEle?.length) {
          if (tablistWrapEle[0].offsetWidth > scrollContentEle[0].offsetWidth) {
            this.canScroll = true;
          } else {
            this.canScroll = false;
          }
        }
      }, 100);
    },
    openDrawer() {
      if (this.isAuthenticated) {
        this.$emit("openDrawer");
      } else {
        if (window.isElectron) {
          this.$router.push({ name: "LoginPage" });
        } else {
          // let preRoute = window.location.href;
          // window.location.href = `${process.env.VUE_APP_ADMIN_URL}/login?return_url=${preRoute}`;
          this.$loginDialog();
        }
      }
    },
    changeTab(id) {
      this.$emit("changeTab", id);
    },
    // 自动滚动
    scrollActiveTab(id) {
      if (this.$refs.scrollContent) {
        let itemEle = document.getElementById(`tab-item-${id}`);
        let totalWidth =
          document.querySelector(".scroll-content")?.offsetWidth || 0;
        let num = totalWidth * 0.45;
        if (itemEle?.offsetLeft > num) {
          this.$refs.scrollContent.scrollLeft = itemEle.offsetLeft - num;
        } else {
          this.$refs.scrollContent.scrollLeft = 0;
        }
      }
    },
    // 左右切换按钮
    scrollTab(direction) {
      if (this.$refs.scrollContent) {
        if (direction === "left") {
          this.$refs.scrollContent.scrollLeft -= 530;
        } else {
          this.$refs.scrollContent.scrollLeft += 530;
        }
      }
    },
  },
  watch: {
    activeTabId: {
      handler: function (newVal) {
        this.activeId = newVal;
      },
      immediate: true,
    },
  },
  computed: {
    ...mapGetters(["isAuthenticated"]),
    hideBanner() {
      let num = 390;
      if (window.isElectron) {
        num = 160;
      }
      return this.bannerList?.length === 0 || this.scrollTop > num;
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.setClassifyTabsEleWidth, true);
    window.removeEventListener("scroll", this.handleScroll, true);
  },
};
</script>

<style lang="scss" scoped>
.classify-tabs-wrap .placeholder-ele {
  height: 50px;
  width: 100%;
  // background: #ffffff;
}
.classify-tabs-wrap .classify-tabs {
  position: fixed;
  width: 100%;
  z-index: 9;
  height: 50px;
  background: rgba(255, 255, 255, 0.8);
  border-top: 1px solid #eaeaea;
  .classify-content {
    position: relative;
    left: -13px;
    display: flex;
    align-items: center;
    width: 1226px;
    margin: 0 auto;
    height: 100%;
    overflow: hidden;
  }
  .scroll-content {
    width: calc(100% - 59px);
    scrollbar-width: 0;
    /* 标准语法，Firefox 支持 */
    -ms-overflow-style: none;
    /* IE 和 Edge */
    &::-webkit-scrollbar {
      display: none;
      /* WebKit 内核浏览器 */
    }
    scroll-snap-type: x mandatory;
    overflow-x: scroll;
    overflow-y: hidden;
    scroll-behavior: smooth;
  }
  .tablist-wrap {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    width: max-content;
    padding-left: 26px;
    padding-right: 10px;
    .tab-item {
      cursor: pointer;
      white-space: nowrap;
      padding: 0px 14px;
      margin-right: 14px;
      font-size: 14px;
      color: $plain-text-color;
      line-height: 28px;
      height: 28px;
    }
    .is-active {
      background: #effff9;
      border-radius: 8px;
      font-weight: 500;
      font-size: 16px;
      color: #333333;
      line-height: 28px;
      padding: 0px 28px;
    }
  }
  // 操作
  .operate-wrap {
    position: absolute;
    top: 0;
    right: 0;
    height: 50px;
    display: flex;
    align-items: center;
    padding: 0 0 0 28px;
    background: transparent;
    .scroll-btn {
      display: flex;
      width: 34px;
      height: 16px;
      background: #ffffff;
      border-radius: 4px;
      border: 1px solid #f0f0f0;
      margin-right: 9px;
    }
    .left-btn,
    .right-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 1;
      cursor: pointer;
      font-weight: bold;
      height: 16px;
      border-radius: 4px 0 0 4px;
      background: transparent;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #d2d7dd;
      font-size: 10px;
      &:hover {
        background: #f0fffb;
        color: $saas-theme-color;
      }
    }
    .edit-btn {
      cursor: pointer;
      width: 16px;
      height: 16px;
    }
  }
}
.hide-banner {
  background: rgba(255, 255, 255, 1) !important;
}

.classify-tabs-wrap.electron-classify-tabs {
  .classify-tabs {
    width: 100% !important;
    background: rgba(255, 255, 255, 0.4);
    left: $side-bar-width;
    .classify-content {
      width: 1000px;
      left: -60px;
    }
  }
  .hide-banner {
    background: #fff;
  }
}

.h5-classify-tabs-wrap {
  .classify-tabs,
  .placeholder-ele {
    height: 1.17rem;
  }
}
.h5-classify-tabs-wrap .classify-tabs {
  position: fixed;
  width: 100%;
  z-index: 9;
  background: #fff;
  .classify-content {
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  .scroll-content {
    width: calc(100% - 1rem);
    scrollbar-width: 0;
    /* 标准语法，Firefox 支持 */
    -ms-overflow-style: none;
    /* IE 和 Edge */
    &::-webkit-scrollbar {
      display: none;
      /* WebKit 内核浏览器 */
    }
    scroll-snap-type: x mandatory;
    overflow-x: scroll;
    overflow-y: hidden;
    scroll-behavior: smooth;
  }
  .tablist-wrap {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    width: max-content;
    .tab-item {
      box-sizing: content-box;
      white-space: nowrap;
      padding: 0.1rem 0.26rem 0.1rem;
      font-size: 0.37rem;
      color: #515350;
      height: 0.53rem;
      line-height: 0.53rem;
    }
    .is-active {
      position: relative;
      font-weight: 500;
      font-size: 0.37rem;
      color: #0d1400;
      &::after {
        z-index: 2;
        content: "";
        position: absolute;
        bottom: 0.05rem;
        left: 50%;
        transform: translateX(-50%);
        width: 0.27rem;
        height: 0.05rem;
        background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
        border-radius: 0.07rem;
      }
    }
  }
  // 操作
  .operate-wrap {
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    display: flex;
    align-items: center;
    padding: 0 0.3rem;
    background: transparent;
    .edit-btn {
      cursor: pointer;
      width: 0.4rem;
      height: 0.4rem;
    }
  }
}
</style>
